import { reducerWithInitialState } from "typescript-fsa-reducers";

import { EntitiesMap } from "../../entities";
import { bootstrapped } from "../actions/Experiments";

export type ExperimentName = "company_nav_feed_name"; // Add experiment name like "| 'foo_exp' | 'bar_exp'"

export interface Experimenting {
  variation: number;
}

export type ExperimentsState = { [key in ExperimentName]?: Experimenting | null };

const initialState: ExperimentsState = {};

function buildState(experimentingIds: EntityId[], entities: EntitiesMap): ExperimentsState {
  const state: ExperimentsState = {};
  experimentingIds.forEach(id => {
    const experimenting = entities.experimentings![id];
    if (experimenting) {
      state[experimenting.experiment_name as ExperimentName] = { variation: experimenting.variation! };
    }
  });
  return state;
}

const experimentsReducer = reducerWithInitialState(initialState).case(bootstrapped, (state, body) => {
  if (body.result && body.result.experimentings && body.entities) {
    return {
      ...state,
      ...buildState(body.result.experimentings, body.entities),
    };
  }
  return state;
});

export default experimentsReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/experiments.ts